import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_REDIRECT_URL } from '@/constants';

const loginSearchSchema = z.object({
  redirect: z.optional(z.string()),
  orgCode: z.optional(z.string()),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;
    const searchParams = new URLSearchParams(location.search);
    const redirectUrl = searchParams.get('redirect');

    if (!auth.isAuthenticated) {
      if (redirectUrl) {
        sessionStorage.setItem('redirectUrl', redirectUrl);
      } else {
        sessionStorage.removeItem('redirectUrl');
      }

      if (redirectUrl === 'signup') {
        await auth.register();
      } else {
        const orgCode = searchParams.get('orgCode');
        await auth.login(orgCode ? { orgCode } : undefined);
      }
    } else {
      const orgCode = searchParams.get('orgCode');
      const currentOrgCode = await auth.getCurrentOrganization();

      if (orgCode && currentOrgCode !== orgCode) {
        await auth.login({ orgCode });
      } else {
        throw redirect({ to: redirectUrl ?? DEFAULT_REDIRECT_URL });
      }
    }
  },
});
